<template>
  <div class="container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="客户端管理" name="clientAdmin">
        <clientAdmin v-if="activeName ===  'clientAdmin'"></clientAdmin>
      </el-tab-pane>
      <el-tab-pane label="识别模块" name="zhiyanWssAdmin">
        <zhiyanWssAdmin v-if="activeName ===  'zhiyanWssAdmin'"></zhiyanWssAdmin>
      </el-tab-pane>
      <el-tab-pane label="检测框模块" name="detectedRegion">
        <regionModuleAdmin v-if="activeName ===  'detectedRegion'"></regionModuleAdmin>
      </el-tab-pane>
      <el-tab-pane label="支付模块" name="paymentAdmin">
        <paymentModuleAdmin v-if="activeName === 'paymentAdmin'"></paymentModuleAdmin>
      </el-tab-pane>
      <el-tab-pane label="碗碟模型" name="dishModelAdmin">
        <dishModelAdmin v-if="activeName === 'dishModelAdmin'"></dishModelAdmin>
      </el-tab-pane>
      <el-tab-pane label="菜品模型" name="foodModelAdmin">
        <foodModelAdmin v-if="activeName === 'foodModelAdmin'"></foodModelAdmin>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiGetAllMachineList} from '@/api';
import paymentModuleAdmin from './paymentModuleAdmin';
import clientAdmin from './clientAdmin';
import zhiyanWssAdmin from './zhiyanWssAdmin';
import regionModuleAdmin from './regionModuleAdmin';
import foodModelAdmin from './foodModelAdmin';
import dishModelAdmin from './dishModelAdmin';

export default {
  name: '',
  components: {
    paymentModuleAdmin,
    zhiyanWssAdmin,
    clientAdmin,
    regionModuleAdmin,
    foodModelAdmin,
    dishModelAdmin
  },
  data () {
    return {
      activeName: 'clientAdmin'
    };
  },
  mounted () {
    this.setSubTitle('版本管理');
    this.getMachineList();
    this.$store.dispatch("setCustomMachineList");
  },
  methods: {
    ...mapMutations([
      'setSubTitle',
      'setAllMachineList'
    ]),
    ...mapActions([]),
    async getMachineList () {
      try {
        const res = await apiGetAllMachineList();
        const allMachineList = res.machine_info_list;
        this.setAllMachineList(allMachineList);
      } catch (e) {
      }
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>
<style>
 .el-tabs__content {
   overflow: visible;
 }
</style>
